import React from 'react';
import './DomainParking.css';

const DomainParking: React.FC = () => {
  return (
    <div className="domain-parking">
      <div className="container">
        <header className="header">
          <h1 className="domain-name">sahariano.com</h1>
          <div className="status-badge">For Sale</div>
        </header>
        
        <main className="main-content">
          <div className="hero-section">
            <h2 className="hero-title">Premium Domain Available</h2>
            <p className="hero-description">
              This premium domain name is available for purchase. 
              Perfect for businesses, startups, or personal projects looking for a memorable web address.
            </p>
          </div>
          
         
          
          <div className="contact-section">
            <h3 className="contact-title">Interested in purchasing?</h3>
            <p className="contact-description">
              Contact us today to discuss pricing and transfer details.
            </p>
            <div className="contact-info">
              <a 
                href="mailto:contact@sahariano.com" 
                className="contact-email"
                aria-label="Send email to contact@sahariano.com"
              >
                contact@sahariano.com
              </a>
            </div>
            <button 
              className="cta-button"
              onClick={() => window.location.href = 'mailto:contact@sahariano.com?subject=Domain Purchase Inquiry - sahariano.com'}
            >
              Make an Offer
            </button>
          </div>
        </main>
        
        <footer className="footer">
          <p>&copy; 2025 Domain Parking. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default DomainParking;
